import * as boHelper              from '../batchOperationDialogActionsHelper';
import * as lotsService from '../../../services/Lots/lotsService';
import {dialogsNames} from '../../../enums/dialogsNames';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import {api as messageDialogApi} from '../../MessageDialog/messageDialogActions';
import * as dialogHelper from 'infrastructure/js/components/Dialog/dialogHelper';
import Network from 'infrastructure/js/modules/network';
import {enumTypes, getEnumValue} from '../../../utils/enumHelper';
/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  ...boHelper.getActionTypes(dialogsNames.EDIT_STATUS_DIALOG),
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
  ...boHelper.getActions(dialogsNames.EDIT_STATUS_DIALOG),
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
const config = {
  submitMethod: lotsService.editLotsStatuses,
  submitWithProgressMethod: lotsService.startCocCsvAutomation,
  dialogReduxStorageName: 'editStatusDialog'
};

export let api = {
  ...boHelper.getApiActions(actions, config),

  submit: function (dispatch, getState) {
    return function (data, messageDialogBuilder, reloadParentComponent, isAutomateMode=false) {
      dispatch(actions.submitInProgress());

      return config?.submitMethod?.(data, api.saveCancelToken(dispatch, getState))
        .then((response) => {

          let validations = dialogHelper.getResponseValidationDetails(response);
          if (validations) {
            dispatch(actions.submitFinished(response));
            dispatch(actions.setValidationWarningsData(validations));
            return {success: false};
          }

          if (!Network.isResponseValid(response)) {
            console.error(config.submitMethod.name + ' failed ', response);
            messageDialogApi.responseError(dispatch, getState)(response);
            dispatch(actions.submitFinished(response));
            dispatch(actions.hide());
            return {success: false};
          }

          if (isAutomateMode) {
            return api.handlePostSubmitFlow(dispatch, getState)(data, response, messageDialogBuilder, reloadParentComponent);
          }

          dispatch(actions.submitFinished(response));
          dispatch(actions.hide());
          return api.handleSubmitResponse(dispatch, getState)(response, messageDialogBuilder, reloadParentComponent);

        })
        .catch((error) => {
          console.error(config.submitMethod.name + ' failed, catch error: ', error);
          dispatch(actions.submitFinished());
          dispatch(actions.hide());
        });
    }
  },

  handlePostSubmitFlow: function (dispatch, getState) {
    return function (data, response, messageDialogBuilder, reloadParentComponent) {

      const lotId = data?.lotsIds?.[0];
      return api.checkCocCsvAutomation(dispatch, getState)(lotId)
        .then((res) => {
          dispatch(actions.submitFinished(response));
          dispatch(actions.hide());
          reloadParentComponent?.();

          if (res?.data?.automationAvailable) {
            return api.submitWithConfirmation(dispatch, getState)(lotId, messageDialogBuilder, reloadParentComponent);
          }

          return api.handleSubmitResponse(dispatch, getState)(response, messageDialogBuilder, reloadParentComponent);
        });
    }
  },

  checkCocCsvAutomation: function (dispatch, getState) {
    return function (lotId) {
      return lotsService.checkCocCsvAutomation(lotId)
        .then((response) => {
          if (!Network.isResponseValid(response)) {
            console.error('checkCocCsvAutomation() failed ', response);
            messageDialogApi.responseError(dispatch, getState)(response);
            return null;
          }
          return response;
        })
        .catch((error) => {
          console.error('checkCocCsvAutomation() failed, catch error: ', error);
          return null;
        });
    };
  },

  submitWithConfirmation: function (dispatch, getState) {
    return function (lotId, messageDialogBuilder, reloadParentComponent) {
      let labels = createLabelHelper('mat.dialog.editStatus.');

      let confirmationConfig = {
        message: labels.get('confirmationBefore.message.title'),
        submitButtonLabel: labels.get('confirmationBefore.footer.ok'),
        cancelHandler: messageDialogApi.close(dispatch, getState),
        submitHandler: () => api.doSubmit(dispatch, getState)(lotId, messageDialogBuilder, reloadParentComponent),
      };

      messageDialogApi.showConfirmation(dispatch, getState)(confirmationConfig);
    }
  },

  doSubmit: function (dispatch, getState) {
    return function (data, messageDialogBuilder, reloadParentComponent) {
      messageDialogApi.close(dispatch, getState)();

      let jobPollingRequest = 'batchJobs/JOB_EXECUTION_ID/status';
      api.submitWithProgress(dispatch, getState)(data, messageDialogBuilder, reloadParentComponent, jobPollingRequest);
    }
  },
}

/////////////////////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {
  ...boHelper.getJsxActions(api),

  submit: function (data, messageDialogBuilder, reloadParentComponent, isAutomateMode=false) {
    return function (dispatch, getState) {
      api.submit(dispatch, getState)(data, messageDialogBuilder, reloadParentComponent, isAutomateMode);
    };
  },
};

